export var valuesUserRoles = ["Admin", "Moderator", "Reader", "Writer"];
/*

*/ 
//# sourceMappingURL=UserRoles.js.map